module.exports =
{
    'API_URL': '/api',
    'LOGOS_URL': '/logos/',
    'FILES_URL': '/files/',
    //'API_URL': 'https://personal-account.expovr.ru/api',
    //'LOGOS_URL': 'https://personal-account.expovr.ru/logos/',
    //'FILES_URL': 'https://personal-account.expovr.ru/files/',
    //'API_URL': 'http://localhost:6080/api',
    //'LOGOS_URL': 'http://localhost:6080/logos/',
    //'FILES_URL': 'http://localhost:6080/files/',
    //'API_URL': 'https://dev.alxgrn.ru/api',
    //'LOGOS_URL': 'https://dev.alxgrn.ru/logos/',
    //'FILES_URL': 'https://dev.alxgrn.ru/files/',
    'PAGE_LIMIT': 12,
}
